import { render, staticRenderFns } from "./OrderListTable.vue?vue&type=template&id=63306b34&scoped=true"
import script from "./OrderListTable.vue?vue&type=script&lang=js"
export * from "./OrderListTable.vue?vue&type=script&lang=js"
import style0 from "./OrderListTable.vue?vue&type=style&index=0&id=63306b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63306b34",
  null
  
)

export default component.exports